var exports = {
  "T": "BoardLayout__HohjaQ",
  "b": "Board__3kJPE_",
};

module.exports = exports;
